module.exports = __webpack_public_path__ + "media/img/logos/bioscientia-31d050a7fe3ddd6d3b4403a2242d2851.png";